import { apiClickProvider } from "./apiClickProvider";
import { mockClickProvider } from "./mockClickProvider";
import { isMockEnabled } from "../../../config/featureConfig";

export const clickProvider = isMockEnabled("click")
  ? mockClickProvider
  : apiClickProvider;

